module.exports = __webpack_public_path__ + "img/zapier.18773112.svg";